import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const planificadorTareaImporterSelectors = importerSelectors(
  'planificadorTarea.importer',
);

export default planificadorTareaImporterSelectors;
